import { FC } from 'react';
import styled, { DefaultTheme } from 'styled-components';

type TaskElementProps = {
  theme: DefaultTheme;
  programId: number;
};

const Container = styled.div(({ theme }) => {
  const { color, type } = theme.new;

  return `
    font-family: ${type.face};
    border-radius: 6px;
    font-size: ${type.size[14]};
    color: ${color.shade[2]};
    font-weight: ${type.weight.regular};
    letter-spacing: 0.0025rem;
    line-height: 1.3125rem;
    padding: 2px 2px 2px 10px;
    display: inline-flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    gap: 6px;
    background-color: ${color.neutral[3]};
    align-items: center;
  `;
});

const Dot = styled.span<TaskElementProps>(({ theme, programId }) => {
  return `
    display: block;
    border-radius: 100px;
    height: 0.5rem;
    width: 0.5rem;
    background-color: ${theme.new.color.program[programId]};
  `;
});

const Label = styled.div`
  flex-grow: 1;
  vertical-align: middle;
`;

const Time = styled.div(({ theme }) => {
  const { color, type } = theme.new;

  return `
    display: flex;
    align-items: center; /* Vertical alignment */
    justify-content: center;
    font-size: ${type.size[12]};
    font-weight: ${type.weight.bold};
    line-height: 1.125rem;
    letter-spacing: 0.02rem;
    color: ${color.neutral[7]};
    background-color: ${color.neutral[2]};
    padding: 0.25rem 0.4375rem;
    border-radius: 0 6px 6px 0;
    height: 100%;
    text-align: center;

    &.incomplete {
      color: ${color.shade[2]};
    }

    &.complete {
      color: ${color.brand[2].dark};
    }
  `;
});

const CheckIcon = styled.i(({ theme }) => {
  const { type, color } = theme.new;
  return `
    font-size: ${type.size[12]};
    color: ${color.brand[2].dark};
    margin-left: 5px;
  `;
});

interface RestorativeTaskProps {
  programId: number;
  children?: React.ReactNode;
  time: number;
  complete?: boolean;
}

const RestorativeTask: FC<RestorativeTaskProps> = ({ programId, children, time }) => {
  let timeColor = 'notStarted';

  if (time > 0) {
    timeColor = 'incomplete';
  }

  let completeCheck = false;
  if (time >= 15) {
    timeColor = 'complete';
    completeCheck = true;
  }

  return (
    <Container>
      <Dot programId={programId} />
      <Label>{children}</Label>
      <Time className={timeColor}>
        {time} min
        {completeCheck && <CheckIcon className="fa fa-check" />}
      </Time>
    </Container>
  );
};

export default RestorativeTask;
